<template>
<v-flex>
  <v-form>
    <v-text-field
      label="Bezeichnung"
      v-model="set.Bezeichnung"
      required
      ></v-text-field>
    <v-select
      :items="verfahren"
      item-text="ID"
      item-value="ID"
      v-model="set.Verfahren"
      label="Verfahren"
      ></v-select>
    <v-flex>
      <label>Produktart</label>
      <v-checkbox
        v-for="opt in arten"
        :key="opt.ID"
        :label="`${opt.Bezeichnung} (${opt.ID})`"
        :value="opt.ID"
        v-model="selectedArten"
        />
    </v-flex>
    <v-flex>
      <label>Industriesektor</label>
      <v-checkbox
        v-for="opt in sektoren"
        :key="opt.Kürzel"
        :label="`${opt.Bezeichnung} (${opt.Kürzel})`"
        :value="opt.Kürzel"
        v-model="selectedSektoren"
        />
    </v-flex>
    <div v-if="set.ID > 0">
      <v-subheader>Bild</v-subheader>
      <img class="set-img" :src="imagePath" v-if="set.img" />
      <FileUploadComponent @input="imageFileSelected" accept=".jpg" />
    </div>
    <v-btn color="success" @click="save">Speichern</v-btn>
    <v-btn @click="cancel">Abbrechen</v-btn>
    </v-form>
  </v-flex>
</template>

<script>
import FileUploadComponent from '../FileUploadComponent.vue';
import utils from '@/utils.js';

export default {
  name: 'EditSetComponent',
  props: ['set', 'arten', 'sektoren', 'verfahren'],
  components: {
    FileUploadComponent
  },
  data() {
    return {
      selectedArten: [],
      selectedSektoren: []
    };
  },
  methods: {
    save() {
      var toSave = this.set;
      toSave.produktarten = this.selectedArten;
      toSave.industriesektoren = this.selectedSektoren;

      this.$emit('onSave', toSave);
    },
    cancel() {
      if (this.set.ID > 0) {
        this.$router.push({ name: 'SingleSet', params: { setId: this.set.ID } });
      } else {
        this.$router.push({ path: '/sets' });
      }
    },
    imageFileSelected(file) {
      var fd = new FormData();
      fd.append('file', file, file.name);
      this.$emit('onUploadImage', fd);
    }
  },
  computed: {
    imagePath() {
      return utils.getImagePath(this.$http.options.root, this.set.img);
    }
  },
  watch: {
    set(val) {
      this.selectedArten = val.produktarten.map(m => m.ID);
      this.selectedSektoren = val.industriesektoren.map(m => m.Kürzel);
    }
  }
};
</script>

<style>
.set-img {
  max-height: 124px;
  max-width: 210px;
}
</style>
